// University of Idaho's bachelor's majors (#2839). Read on 2026-10-01 from
// the University of Idaho 2026-2027 Catalog (catalog.uidaho.edu), "Academic
// Offerings at the University of Idaho": every row of its Undergraduate table
// with an entry in the Bachelor column (106 programs), with that column's
// degree. Each is grouped by the college whose catalog page the row links
// to. The table marks programs available online with an asterisk; the
// asterisks are dropped. Career and Technical Education's "B.S.E.d" is typed
// as B.S.Ed., the degree its own catalog page and Elementary and Secondary
// Education carry. Where a row offers two or three degrees (B.A./B.S.), it
// stays one entry, as the catalog lists it. Left out: minors, associate
// degrees, academic certificates and graduate programs.
const majors = {
    "slug": "university-of-idaho",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree program in the University of Idaho's official 2026-2027 Catalog, grouped by the college that offers it, with the degree it leads to. Minors, certificates, associate degrees and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Agricultural and Life Sciences",
            "source": {
                "label": "University of Idaho 2026-2027 Catalog, College of Agricultural and Life Sciences",
                "url": "https://catalog.uidaho.edu/colleges-related-units/agricultural-life-sciences/"
            },
            "majors": [
                {
                    "name": "Agricultural Economics",
                    "degree": "B.S.Ag.Econ."
                },
                {
                    "name": "Agricultural Education",
                    "degree": "B.S.Ag.Ed."
                },
                {
                    "name": "Agricultural Science, Communication and Leadership",
                    "degree": "B.S.Ag.L.S."
                },
                {
                    "name": "Agricultural Systems Management",
                    "degree": "B.S.S.W.S."
                },
                {
                    "name": "Animal and Veterinary Science",
                    "degree": "B.S.A.V.S."
                },
                {
                    "name": "Apparel, Textiles and Design",
                    "degree": "B.S."
                },
                {
                    "name": "Biotechnology and Plant Genomics",
                    "degree": "B.S.Pl.Sc."
                },
                {
                    "name": "Child Development",
                    "degree": "B.S."
                },
                {
                    "name": "Crop Science and Management",
                    "degree": "B.S.Pl.Sc."
                },
                {
                    "name": "Early Childhood Education",
                    "degree": "B.S."
                },
                {
                    "name": "Entomology",
                    "degree": "B.S.Ag.L.S."
                },
                {
                    "name": "Environmental Soil Science",
                    "degree": "B.S.S.W.S."
                },
                {
                    "name": "Family and Consumer Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Food and Nutrition",
                    "degree": "B.S."
                },
                {
                    "name": "Food Science",
                    "degree": "B.S.F.S."
                },
                {
                    "name": "Global Disease Ecology",
                    "degree": "B.S."
                },
                {
                    "name": "Horticulture and Urban Agriculture",
                    "degree": "B.S.Pl.Sc."
                },
                {
                    "name": "Human Development and Family Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Nutritional Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Sustainable Food Systems",
                    "degree": "B.S.Ag.L.S."
                },
                {
                    "name": "Water Science and Management",
                    "degree": "B.S.S.W.S."
                }
            ]
        },
        {
            "name": "College of Art and Architecture",
            "source": {
                "label": "University of Idaho 2026-2027 Catalog, College of Art and Architecture",
                "url": "https://catalog.uidaho.edu/colleges-related-units/art-architecture/"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "B.S.Arch."
                },
                {
                    "name": "Art",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Design",
                    "degree": "B.S.E.D."
                },
                {
                    "name": "Interior Architecture and Design",
                    "degree": "B.I.A.D."
                },
                {
                    "name": "Studio Art and Design",
                    "degree": "B.F.A."
                },
                {
                    "name": "Virtual Technologies",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Business and Economics",
            "source": {
                "label": "University of Idaho 2026-2027 Catalog, College of Business and Economics",
                "url": "https://catalog.uidaho.edu/colleges-related-units/business-economics/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.S.Bus."
                },
                {
                    "name": "Business Administration",
                    "degree": "B.B.A."
                },
                {
                    "name": "Business Economics",
                    "degree": "B.S.Bus."
                },
                {
                    "name": "Business Information and Analytics",
                    "degree": "B.S.Bus."
                },
                {
                    "name": "Business Management",
                    "degree": "B.S.Bus."
                },
                {
                    "name": "Economics",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Finance",
                    "degree": "B.S.Bus."
                },
                {
                    "name": "Marketing",
                    "degree": "B.S.Bus."
                },
                {
                    "name": "Operations and Supply Chain Management",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Education, Health and Human Sciences",
            "source": {
                "label": "University of Idaho 2026-2027 Catalog, College of Education, Health and Human Sciences",
                "url": "https://catalog.uidaho.edu/colleges-related-units/education-health-human-sciences/"
            },
            "majors": [
                {
                    "name": "Career and Technical Education",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Dance",
                    "degree": "B.S.Dan."
                },
                {
                    "name": "Elementary Education",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Exercise, Sport and Health Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Secondary Education",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Sport and Recreation Management",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "University of Idaho 2026-2027 Catalog, College of Engineering",
                "url": "https://catalog.uidaho.edu/colleges-related-units/engineering/"
            },
            "majors": [
                {
                    "name": "Artificial Intelligence",
                    "degree": "B.S."
                },
                {
                    "name": "Biological Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "B.S.Ch.E."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.S.C.E."
                },
                {
                    "name": "Computer Engineering",
                    "degree": "B.S.Comp.E."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S.C.S."
                },
                {
                    "name": "Cybersecurity",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S.E.E."
                },
                {
                    "name": "Electrical Engineering - Global",
                    "degree": "B.S.E.E."
                },
                {
                    "name": "Engineering Technology",
                    "degree": "B.S.Tech."
                },
                {
                    "name": "Geological Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Industrial and Systems Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S.M.E."
                }
            ]
        },
        {
            "name": "College of Letters, Arts and Social Sciences",
            "source": {
                "label": "University of Idaho 2026-2027 Catalog, College of Letters, Arts and Social Sciences",
                "url": "https://catalog.uidaho.edu/colleges-related-units/letters-arts-social-sciences/"
            },
            "majors": [
                {
                    "name": "Advertising",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Applied Music",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Broadcasting and Digital Media",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Communication",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Criminology",
                    "degree": "B.S."
                },
                {
                    "name": "English",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Film and Television",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "French",
                    "degree": "B.A."
                },
                {
                    "name": "General Studies",
                    "degree": "B.G.S."
                },
                {
                    "name": "Global Business Language Studies",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "International Studies",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Journalism",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Latin American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Music Education",
                    "degree": "B.Mus."
                },
                {
                    "name": "Music Business",
                    "degree": "B.Mus."
                },
                {
                    "name": "Music Composition",
                    "degree": "B.Mus."
                },
                {
                    "name": "Music Performance",
                    "degree": "B.Mus."
                },
                {
                    "name": "Organizational Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Public Relations",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre Arts",
                    "degree": "B.A./B.F.A./B.S."
                }
            ]
        },
        {
            "name": "College of Natural Resources",
            "source": {
                "label": "University of Idaho 2026-2027 Catalog, College of Natural Resources",
                "url": "https://catalog.uidaho.edu/colleges-related-units/natural-resources/"
            },
            "majors": [
                {
                    "name": "Conservation Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Ecology and Ecosystem Science",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Science",
                    "degree": "B.S.Env.S."
                },
                {
                    "name": "Fire Ecology and Management",
                    "degree": "B.S.Fire.Ecol.Mgmt."
                },
                {
                    "name": "Fisheries Science",
                    "degree": "B.S."
                },
                {
                    "name": "Forest and Sustainable Products",
                    "degree": "B.S."
                },
                {
                    "name": "Forestry",
                    "degree": "B.S.Forestry"
                },
                {
                    "name": "Natural Resources Enterprise Management",
                    "degree": "B.S."
                },
                {
                    "name": "Rangeland Ecology and Management",
                    "degree": "B.S."
                },
                {
                    "name": "Wildlife Sciences",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Science",
            "source": {
                "label": "University of Idaho 2026-2027 Catalog, College of Science",
                "url": "https://catalog.uidaho.edu/colleges-related-units/science/"
            },
            "majors": [
                {
                    "name": "Biochemistry",
                    "degree": "B.S.Biochem."
                },
                {
                    "name": "Bioinformatics",
                    "degree": "B.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Climate Change",
                    "degree": "B.S."
                },
                {
                    "name": "Earth and Spatial Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Geographic Information Systems",
                    "degree": "B.S."
                },
                {
                    "name": "Geology",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Medical Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Microbiology",
                    "degree": "B.S.Microbiol."
                },
                {
                    "name": "Physics",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Statistics",
                    "degree": "B.S."
                }
            ]
        }
    ]
};

export default majors;
